(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["captain-growth"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.captainGrowthReady) return;
  window.captainGrowthReady = true;
  const root = document.getElementById('CaptainGrowth');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const storeKey = 'cm_campaign_v1';
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const safeCampaign = value => /^[a-zA-Z0-9_-]{1,80}$/.test(value || '') ? value : '';
  const safeModel = value => /^[\p{L}\p{N} +.,()/_–-]{1,120}$/u.test(value || '') ? value : '';
  const safePath = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?(?:products|collections|blogs|pages)(?:\/|$)/.test(url.pathname) && !/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/?)?$/.test(url.pathname)) return '';
      return url.pathname.slice(0, 240);
    } catch { return ''; }
  };
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  let campaign = null;
  function refreshCampaign() {
    if (!allowed()) {
      campaign = null;
      try { sessionStorage.removeItem(storeKey); } catch {}
      return;
    }
    let stored = null;
    try { stored = JSON.parse(sessionStorage.getItem(storeKey)); } catch {}
    const current = Object.fromEntries(campaignKeys.map(key => [key, safeCampaign(params.get(key))]));
    if (current.utm_source || current.utm_campaign) {
      campaign = { ...current, landing: safePath(location.href), time: Date.now() };
    } else if (stored && Date.now() - stored.time < 1800000) {
      campaign = { ...Object.fromEntries(campaignKeys.map(key => [key, safeCampaign(stored[key])])), landing: safePath(stored.landing), time: stored.time };
    } else {
      campaign = null;
    }
    try { if (campaign) sessionStorage.setItem(storeKey, JSON.stringify(campaign)); else sessionStorage.removeItem(storeKey); } catch {}
  }
  refreshCampaign();
  document.addEventListener('visitorConsentCollected', refreshCampaign);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) refreshCampaign(); });
  }
  const currentModel = () => {
    const model = safeModel(root.dataset.model);
    const variant = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    return { model, variant: /^\d{1,20}$/.test(variant || '') ? variant : '' };
  };
  const inboundModel = safeModel(params.get('cm_model'));
  const inboundVariant = /^\d{1,20}$/.test(params.get('cm_variant') || '') ? params.get('cm_variant') : '';
  const inboundPath = safePath(params.get('cm_from') || '');
  const forms = () => [...document.querySelectorAll('form')].filter(form => form.querySelector('input[name="form_type"][value="contact"]'));
  function field(form, name, value) {
    let input = form.elements.namedItem('contact[' + name + ']');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + name + ']';
      form.append(input);
    }
    input.value = value || '';
  }
  function prepareForm(form) {
    const product = currentModel();
    field(form, 'Page', safePath(location.href));
    field(form, 'Origin page', inboundPath || safePath(location.href));
    field(form, 'Model', product.model || inboundModel);
    field(form, 'Variant ID', product.variant || inboundVariant);
    if (!form.elements.namedItem('contact[Lead reference]')) {
      const id = window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      field(form, 'Lead reference', 'CM-' + id);
    }
    if (inboundModel && !form.querySelector('.cm-request-context') && form.querySelector('[name="contact[email]"]')) {
      const context = document.createElement('p');
      context.className = 'cm-request-context';
      context.textContent = root.dataset.contextLabel + ' ' + inboundModel;
      form.prepend(context);
      const project = form.elements.namedItem('contact[Project]');
      if (project && params.get('cm_project') === 'purchase') project.selectedIndex = 2;
      if (project && params.get('cm_project') === 'hosting') project.selectedIndex = 0;
    }
  }
  forms().forEach(prepareForm);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('input[name="form_type"][value="contact"]')) return;
    prepareForm(form);
    refreshCampaign();
    campaignKeys.forEach(key => field(form, key, campaign?.[key] || ''));
    field(form, 'Campaign landing page', campaign?.landing || '');
  }, true);
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;
    let url;
    try { url = new URL(anchor.href, location.href); } catch { return; }
    if (url.origin !== location.origin || !url.pathname.endsWith('/pages/contact-captainmining')) return;
    url.searchParams.set('cm_from', safePath(location.href));
    const product = currentModel();
    if (product.model && !url.searchParams.has('cm_model')) url.searchParams.set('cm_model', product.model);
    if (product.variant && !url.searchParams.has('cm_variant')) url.searchParams.set('cm_variant', product.variant);
    anchor.href = url.toString();
  }, true);
  const mobile = root.querySelector('.cm-mobile-project');
  if (!mobile) return;
  const localForm = forms().find(form => form.closest('#MainContent'));
  if (localForm?.id) mobile.href = '#' + localForm.id;
  const visible = element => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
  };
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const toolbar = document.querySelector('toolbar-mobile');
    root.style.setProperty('--cm-toolbar-height', toolbar && visible(toolbar) ? toolbar.getBoundingClientRect().height + 'px' : '0px');
    const overlay = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, dialog[open], [role="dialog"], #header-group details[open], .drawer.active, .drawer.is-open, .popup.is-open')].some(visible);
    const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    const nearForm = forms().some(form => visible(form));
    mobile.hidden = innerWidth > 749 || scrollY < 320 || overlay || editing || nearForm;
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
  ['scroll', 'resize'].forEach(name => window.addEventListener(name, schedule, { passive: true }));
  ['focusin', 'focusout', 'click', 'visitorConsentCollected'].forEach(name => document.addEventListener(name, schedule));
  if (window.ResizeObserver) { const observer = new ResizeObserver(schedule); observer.observe(document.body); }
  if (window.MutationObserver) {
    new MutationObserver(records => { if (records.some(record => !root.contains(record.target))) schedule(); }).observe(document.body, { attributes: true, attributeFilter: ['class', 'open', 'hidden', 'aria-hidden'], subtree: true, childList: true });
  }
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collapsible-text"] && !Shopify.designMode) return;
  try {
    class CollapsibleTextComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.content = this.querySelector('.collapsible-text-content');
      this.button = this.querySelector('.collapsible-text-button-wrapper');
      this.buttonText = this.button.querySelector('button');
      
      if (!this.button || !this.content) return;

      this.showText = this.buttonText.getAttribute('data-show-text');
      this.hideText = this.buttonText.getAttribute('data-hide-text');
      this.isExpanded = false;

      this.checkIfButtonNeeded();
      this.setupEventListeners();
    }

    checkIfButtonNeeded() {
      const contentHeight = this.content.scrollHeight;
      const previewHeight = this.content.getAttribute('data-content-height');
      
      if (contentHeight <= previewHeight) {
        this.button.style.display = 'none';
        this.content.classList.remove('collapsed');
      }
    }

    setupEventListeners() {
      this.button.addEventListener('click', () => {
        this.toggleContent();
      });
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.content.classList.remove('collapsed');
        this.content.classList.add('expanded');
        this.buttonText.textContent = this.hideText;
        this.button.setAttribute('aria-expanded', 'true');
      } else {
        this.content.classList.remove('expanded');
        this.content.classList.add('collapsed');
        this.buttonText.textContent = this.showText;
        this.button.setAttribute('aria-expanded', 'false');
      }
    }
  }
  if (!customElements.get('collapsible-text-component')) customElements.define('collapsible-text-component', CollapsibleTextComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
